export var ONE_BY_ONE_INCREMENTER = "oneByOne";
export var PROGRESS_INCREMENTER = "progress";
